<template>
  <section class="practice">
    <div class="row">
      <aside class="col-md-3 col-sm-12 cus-sidebar">
        <practiceSidebar />
      </aside>
      <div v-if="isLoading" class="loader">
        <div class="wave-container">
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
        </div>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" id="content" class="col-md-9 col-sm-12">
        <!-- <div v-if="this.userfocusData && this.userfocusData > 0" class="material-box bg-white"> -->
        <div
          v-if="(loginUser.Status !== 'PDC' && this.userfocusData && this.userfocusData > 0) || loginUser.Status === 'PDC' || loginUser.Status === 'PCA'"
          class="material-box bg-white">
          <div class="row content-row">
            <div class="col-md-12 top-title">
              <h3>Success Rate Graphs</h3>
            </div>
            <div class="col-md-12">
              <div class="p-b-10 glop_dap">
                <div class="row">
                  <div class="col-md-12">
                    <div class="widget-form">
                      <div class="widget-body p-b-15">
                        <form class="form-input-flat" method="POST" name="sample_form"
                          action="https://dctrainings.com:443/gts/?Module=Home&amp;Page=InputQuarterGoal">
                          <div class="row" style="align-items: flex-end; display: flex; flex-wrap: wrap;">
                            <div class="col-lg-2 col-md-4 col-sm-6 form-group">
                              <label class="control-label">Select User</label>
                              <b-form-select v-model="focusData.UserID" @change="getChartData" required>
                                <option value="">Practice</option>
                                <option :value="user.UserID" v-for="(user, i) in allUsers" :key="i">
                                  {{ user.FirstName }} {{ user.LastName }}
                                </option>
                              </b-form-select>
                            </div>
                            <div
                              :class="[primaryReportType === 'NP' || primaryReportType === 'PV' || primaryReportType === 'REV' ? 'col-lg-2' : 'col-lg-3', 'col-md-4 col-sm-6 form-group']">
                              <label>Select Graph</label>
                              <b-form-select v-model="primaryReportType" @change="onPrimaryChange" required>
                                <option value="">Select Focus</option>
                                <option :value="focus.FocusCode" v-for="focus in allFoucs" :key="focus.FocusCode">
                                  {{ focus.FocusName }}
                                </option>
                              </b-form-select>
                            </div>
                            <div class="col-lg-2 col-md-4 col-sm-6 form-group"
                              v-if="primaryReportType === 'NP' || primaryReportType === 'PV' || primaryReportType === 'REV'">
                              <label>Select Type</label>
                              <b-form-select v-model="subReportType" @change="onSubChange" required>
                                <option value="TOTAL">Total</option>
                                <option value="MONTHLY">Monthly</option>
                              </b-form-select>
                            </div>
                            <div class="col-lg-2 col-md-4 col-sm-6 form-group">
                              <label class="control-label">Select Year</label>
                              <b-form-select id="Prefix" v-model="form.year" :options="years" @change="getChartData">
                              </b-form-select>
                            </div>
                            <div class="col-lg-4 col-md-8 col-sm-12 flex-btns form-group">
                              <b-button @click="resetGraph" class="btn btn-default mr-1 btn-white m-t-20" style="
                                  background: #ffffff;
                                  color: #000000;
                                  margin-right: 2px;
                                ">Reset</b-button>
                              <b-button @click="getChartData" class="btn btn-primary btn-blue m-t-20"
                                style="background: #305397; color: #ffffff">Submit</b-button>
                              <b-button :disabled="isTableLoading" @click="printData"
                                class="btn btn-default btn-white mt-1 ml-1 pull-right m-t-20"
                                style="background: #ffffff; color: #000000">PrintGraph</b-button>
                            </div>
                          </div>
                          <div class="row quarter-btn">
                            <div class="col-md-12">
                              <br />
                              <br />
                              <h4 style="color: grey; font-size: 21px">
                                {{ loginUser.PracticeName }}
                              </h4>
                              <h3 style="
                                  font-size: 20px;
                                  font-family: Calibri;
                                  color: #305397;
                                  font-weight: bold;
                                  text-align: left;
                                  margin-left: 0;
                                ">
                                Success Rate Report -
                                {{ getSelectedReportLabel }} - {{ form.year }}
                              </h3>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="print-box" style="position: relative;">
                  <div v-if="isTableLoading"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; z-index: 10; background: rgba(255, 255, 255, 0.4);">
                    <div class="spinner-border" role="status"
                      style="width: 3rem; height: 3rem; border-color: #305397; border-right-color: transparent;">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div
                    :style="isTableLoading ? 'filter: blur(4px); transition: filter 0.2s;' : 'transition: filter 0.2s;'">
                    <div>
                      <LineChart ref="lineChart" class="chart-data" :key="chartKey" :chartData="chartData"
                        :chartOptions="chartOptions">
                      </LineChart>
                    </div>
                    <!-- <div>
                                        <LineChart
                                        id="line"
                                        :data="chartData"
                                        xkey="m_name"
                                        :ykeys="['goal', 'actual']"
                                        :labels="['Goal', 'Actual']"
                                        :line-colors="['#FF6384', '#36A2EB']"
                                        :grid="true"
                                        grid-text-weight="bold"
                                        :resize="true"
                                        ></LineChart>
                                    </div> -->
                    <div class="row mt-4" style="margin: 0px !important; overflow: auto">
                      <table ref="table" class="table table-bordered comnTbl" v-bind:class="{
                        'table-finding':
                          selectedReportType === 'ROF' ||
                          selectedReportType === 'CPR',
                        'table-new':
                          selectedReportType !== 'ROF' &&
                          selectedReportType !== 'CPR',
                      }">
                        <tr>
                          <th></th>
                          <template v-for="(item, index) in goals">
                            <th :key="index"
                              v-if="!(index === 0 && (selectedReportType.startsWith('NP') || selectedReportType.startsWith('PV') || selectedReportType.startsWith('REV')))">
                              {{ item.m_name }}</th>
                          </template>
                          <template v-if="
                            selectedReportType === 'ROF' ||
                            selectedReportType === 'CPR'
                          ">
                            <!-- <th>{{ goals[11].m_name }}</th> -->
                          </template>
                        </tr>
                        <tr>
                          <td><strong>Goal:</strong></td>
                          <template v-for="(item, index) in goals">
                            <td :key="index"
                              v-if="!(index === 0 && (selectedReportType.startsWith('NP') || selectedReportType.startsWith('PV') || selectedReportType.startsWith('REV')))">
                              <span v-if="selectedReportType.startsWith('REV')">$ {{ item.goal }} </span>
                              <span v-if="selectedReportType === 'ROF' || selectedReportType === 'CPR'">{{ item.goal
                              }}</span>
                              <span v-if="selectedReportType.startsWith('NP') || selectedReportType.startsWith('PV')">{{
                                item.goal }}</span>
                            </td>
                          </template>
                        </tr>
                        <tr>
                          <td><strong>Actual:</strong></td>
                          <template v-for="(item, index) in goals">
                            <td :key="index"
                              v-if="!(index === 0 && (selectedReportType.startsWith('NP') || selectedReportType.startsWith('PV') || selectedReportType.startsWith('REV')))">
                              <span
                                v-if="selectedReportType.startsWith('REV') && item.actual !== undefined && item.actual !== null && !isNaN(item.actual)">
                                $ {{ item.actual }}
                              </span>
                              <span
                                v-if="(selectedReportType === 'ROF' || selectedReportType === 'CPR') && item.actual !== undefined && item.actual !== null && !isNaN(item.actual)">
                                {{ item.actual }}
                              </span>
                              <span v-if="selectedReportType.startsWith('NP') || selectedReportType.startsWith('PV')">{{
                                item.actual
                              }}</span>
                            </td>
                          </template>
                        </tr>
                        <tr>
                          <td><strong>Success Rate:</strong></td>
                          <template v-for="(item, index) in goals">
                            <td :key="index"
                              v-if="!(index === 0 && (selectedReportType.startsWith('NP') || selectedReportType.startsWith('PV') || selectedReportType.startsWith('REV')))">
                              {{ item.avg !== undefined && item.avg !== null && !isNaN(item.avg) ? `${item.avg}%` : ''
                              }}
                            </td>
                          </template>
                        </tr>

                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="material-box bg-white">
          <div class="row content-row">
            <div class="col-md-12 top-title">
              <h3>Success Rate Graphs</h3>
            </div>
            <p style=" margin-left: 2%;">Sorry You have no assigned focus</p>
          </div>
        </div>
        <div id="footer" class="footer">
          <span class="pull-right">
            <a href="javascript:;" class="btn-scroll-to-top" data-click="scroll-top">
              <i class="fa fa-arrow-up"></i>
              <span class="hidden-xs">Back to Top</span>
            </a>
          </span>
          © 2023 <b>Goals Tracking System</b> All Right Reserved
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import practiceSidebar from "./components/Sidebar.vue";
import moment from "moment";
import userAPI from "../userApi";
import jsPDF from "jspdf";
import Vue from "vue";
import "jspdf-autotable";
import LineChart from "./quarter/LineChart.vue";

export default {
  name: "success_rate",
  components: {
    practiceSidebar,
    // apexchart: VueApexCharts,
    LineChart,
  },
  data() {
    return {
      isLoading: false,
      isTableLoading: true,
      chartKey: 0, // Key for re-rendering the LineChart component
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
      selectedReportType: "NP_TOTAL",
      selectedReportType1: "NP_TOTAL",
      primaryReportType: "NP",
      subReportType: "TOTAL",
      focusData: {
        UserID: "",
        FocusCode: "",
        startDate: "",
        PracticeID: "",
      },
      userfocusData: 1,
      allMembersResultValue: "",
      loginUser: {},
      userFocuses: {},
      allUsers: {},
      allFoucs: {},
      years: [],
      goals: [],
      form: {
        year: moment().format("Y"),
      },
    };
  },
  // watch: {
  //     selectedReportType: function(newVal, oldVal) {
  //         this.getGraphData();
  //     }
  // },
  methods: {
    formatValue(value) {
      // Check if the value is a valid number
      if (!isNaN(value)) {
        // Use toFixed() method to format to two decimal places
        return parseFloat(value).toFixed(0);
      } else {
        // Return the original value if it's not a valid number
        return value;
      }
    },
    updateChartData(newChartData) {
      // Update the chartData
      this.chartData = newChartData;

      // Increment the chartKey to force re-rendering of the LineChart component
      this.chartKey++;
    },
    getUserFocusesById() {
      userAPI.getUserFocusesById(
        { userid: this.loginUser.userID },
        (res) => {
          this.userfocusData = res.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getAllFoucs() {
      userAPI.getAllFoucs(
        (res) => {
          this.allFoucs = res.data.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },

    setYears() {
      let currentYear = parseInt(moment().format("Y")) + 1;
      for (let index = 2018; index <= currentYear; index++) {
        this.years.push(index);
      }
    },
    getUsersByPractice() {
      this.isLoading = true;
      userAPI.getUsersByPractice(
        { practiceID: this.loginUser.PracticeID },
        (res) => {
          this.allUsers = res.data.data;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },

    getChartData() {
      this.isTableLoading = true;
      this.selectedReportType = this.selectedReportType1;
      userAPI.getChartData(
        {
          reportType: this.selectedReportType,
          reportYear: this.form.year,
          PracticeID: this.loginUser.PracticeID,
          UserID: this.focusData.UserID ? this.focusData.UserID : 0,
        },
        (res) => {
          this.goals = res.data.data;

          // Get the current month index (0-based)
          const currentMonthIndex = new Date().getMonth();
          const currentYear = new Date().getFullYear();

          // For NP/PV/REV MONTHLY, index 0 is the cumulative "Total" row — skip it so the chart starts from January
          // For TOTAL subtypes, index 0 is already January — no slicing needed
          const isMonthlySubtype = this.selectedReportType.endsWith('_MONTHLY');
          const chartSourceData = isMonthlySubtype ? res.data.data.slice(1) : res.data.data;

          this.chartData = {
            labels: chartSourceData.map(goal => goal.m_name),
            datasets: [
              {
                label: "Goal",
                data: chartSourceData
                  .map((goal) => {
                    if (this.selectedReportType === "ROF" || this.selectedReportType === "CPR") {
                      return goal.Target;
                    } else {
                      return goal.goal;
                    }
                  }).filter((data) => data !== null),
                borderColor: "#ecb201",
                borderWidth: 2,
                fill: false,
              },
              {
                label: "Actual",
                data: chartSourceData.map((goal, index) => {
                  const isPastYear = parseInt(this.form.year) < currentYear;

                  if (this.selectedReportType === 'ROF' || this.selectedReportType === 'CPR') {
                    // ROF/CPR: show up to and including the current month
                    if (isPastYear || index <= currentMonthIndex) {
                      return goal.avg !== null ? goal.avg : 0;
                    }
                    return null;
                  } else if (isMonthlySubtype) {
                    // MONTHLY: only show fully completed months (strictly before current month)
                    if (isPastYear || index < currentMonthIndex) {
                      return goal.actual !== null ? goal.actual : 0;
                    }
                    return null;
                  } else {
                    // TOTAL: show up to and including the current month
                    if (isPastYear || index <= currentMonthIndex) {
                      return goal.actual !== null ? goal.actual : 0;
                    }
                    return null;
                  }
                }),
                borderColor: "#1b17bb",
                borderWidth: 2,
                fill: false,
                spanGaps: false,
              },
              {
                label: '',
                data: (() => {
                  if (this.selectedReportType === 'ROF' || this.selectedReportType === 'CPR') {
                    return [40, 60, 70, 100];
                  } else if (this.selectedReportType.startsWith("REV")) {
                    return ['100,000', '200,000'];
                  } else {
                    return [];
                  }
                })(),
                borderColor: "transparent",
                borderWidth: 0,
                fill: false,
                showLine: false,
                pointRadius: 0,
                pointHoverRadius: 0,
                pointHitRadius: 0,
              },
            ],
          };

          const vm = this;
          const isNPPVREV = this.selectedReportType.startsWith('NP') || this.selectedReportType.startsWith('PV') || this.selectedReportType.startsWith('REV');
          this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              labels: {
                filter: function (item, chartData) {
                  return item.text !== '';
                }
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: !isNPPVREV,
                },
              }],
            },
            tooltips: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function (tooltipItem, data) {
                  let label = data.datasets[tooltipItem.datasetIndex].label || '';
                  if (label) {
                    label += ': ';
                  }
                  let val = tooltipItem.yLabel;
                  if (val === null || val === undefined || isNaN(val)) {
                    return label + '0';
                  }
                  if (vm.selectedReportType.startsWith('REV')) {
                    return label + '$' + parseFloat(val).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                  } else if (vm.selectedReportType === 'ROF' || vm.selectedReportType === 'CPR') {
                    return label + parseFloat(val).toFixed(0) + '%';
                  } else {
                    return label + parseFloat(val).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                  }
                }
              }
            },
            hover: {
              mode: 'index',
              intersect: false,
            }
          };

          this.updateChartData(this.chartData);
          this.isTableLoading = false;
        },
        (err) => {
          console.log(err);
          this.isTableLoading = false;
        }
      );
    },
    onPrimaryChange() {
      if (this.primaryReportType === 'NP' || this.primaryReportType === 'PV' || this.primaryReportType === 'REV') {
        this.selectedReportType1 = this.primaryReportType + '_' + this.subReportType;
      } else {
        this.selectedReportType1 = this.primaryReportType;
      }
      this.getChartData();
    },
    onSubChange() {
      if (this.primaryReportType === 'NP' || this.primaryReportType === 'PV' || this.primaryReportType === 'REV') {
        this.selectedReportType1 = this.primaryReportType + '_' + this.subReportType;
        this.getChartData();
      }
    },
    resetGraph() {
      console.log("Reset");
      this.primaryReportType = "NP";
      this.subReportType = "TOTAL";
      this.selectedReportType = "NP_TOTAL";
      this.selectedReportType1 = "NP_TOTAL";
      this.form.year = new Date().getFullYear();
      this.focusData.UserID = "";
      this.getChartData();
    },
    printData() {
      const doc = new jsPDF();
      const table = this.$refs.table;

      // Set Document Properties (clean filename / tab title in PDF viewer)
      const reportLabel = this.getSelectedReportLabel;
      doc.setProperties({
        title: `${reportLabel} - ${this.form.year}`
      });

      // 1. Header Section
      // Main title
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(48, 83, 151); // Theme blue: #305397
      doc.text("Success Rate Graphs", 15, 16);

      // Company name (grey)
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(150, 150, 150); // Grey
      doc.text(this.loginUser.PracticeName || "Sawyer Chiropractic Group", 15, 22);

      // Sub-heading: Success Rate Report - [Report Label] - [Year] (dark black)
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Dark black
      doc.text(`Success Rate Report - ${this.getSelectedReportLabel} - ${this.form.year}`, 15, 28);

      // Top Divider Line
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(15, 32, 195, 32);

      let startY = 37;
      const chartComponent = this.$refs.lineChart;
      if (chartComponent) {
        const canvas = chartComponent.$el && chartComponent.$el.tagName === 'CANVAS'
          ? chartComponent.$el
          : (chartComponent.$el && chartComponent.$el.querySelector('canvas'));
        if (canvas) {
          try {
            const chartImage = canvas.toDataURL("image/png");
            doc.addImage(chartImage, 'PNG', 15, startY, 180, 85);
            // Divider Line between Graph and Table
            doc.setDrawColor(200, 200, 200);
            doc.setLineWidth(0.5);
            doc.line(15, 124, 195, 124);

            startY = 130;
          } catch (e) {
            console.error("Error capturing chart image:", e);
          }
        }
      }

      // 2. Styled Table Section
      doc.autoTable({
        html: table,
        startY: startY,
        theme: 'grid',
        margin: { left: 10, right: 10 },
        headStyles: {
          fillColor: [48, 83, 151], // Theme blue
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          halign: 'center',
          fontSize: 6.8,
          cellPadding: 1
        },
        styles: {
          font: 'helvetica',
          fontSize: 6.8,
          cellPadding: 1,
          halign: 'center',
          valign: 'middle'
        },
        columnStyles: {
          0: {
            halign: 'left',
            fontStyle: 'bold',
            fillColor: [245, 247, 250], // Light background for row labels column
            cellWidth: 24,
            fontSize: 7
          }
        }
      });

      const filename = `${reportLabel} - ${this.form.year}.pdf`;
      const blob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(blob);
      this.openPdfInNewTab(pdfUrl, filename);
    },

    openPdfInNewTab(pdfUrl, filename) {
      const newTab = window.open();
      if (newTab) {
        newTab.document.write(
          `<html><head><title>${filename}</title></head>` +
          `<body style="margin:0;"><iframe src="${pdfUrl}" style="width:100%; height:100%; border:none;"></iframe></body></html>`
        );
        newTab.document.close();
      }
    },
  },
  mounted() {
    this.setYears();
    this.loginUser = JSON.parse(localStorage.getItem("userDetails"));
    let user = JSON.parse(localStorage.getItem("userDetails"));
    this.loginUser = user;

    // if (user.Status == "DC" || user.Status == "CA") {
    //   this.$router.push({ name: "user_dashboard" });
    // }
    this.getUsersByPractice();
    this.getChartData();
    this.getAllFoucs();
    this.getUserFocusesById();
  },
  computed: {
    getSelectedReportLabel() {
      console.log(this.selectedReportType);
      if (this.selectedReportType === "NP_TOTAL" || this.selectedReportType === "NP") {
        return "New Patient (Total)";
      } else if (this.selectedReportType === "NP_MONTHLY") {
        return "New Patient (Monthly)";
      } else if (this.selectedReportType === "ROF") {
        return "Report of Findings";
      } else if (this.selectedReportType === "PV_TOTAL" || this.selectedReportType === "PV") {
        return "Patient Visits (Total)";
      } else if (this.selectedReportType === "PV_MONTHLY") {
        return "Patient Visits (Monthly)";
      } else if (this.selectedReportType === "CPR") {
        return "Care Plan Renewals";
      } else if (this.selectedReportType === "REV_TOTAL" || this.selectedReportType === "REV") {
        return "Revenue (Total)";
      } else if (this.selectedReportType === "REV_MONTHLY") {
        return "Revenue (Monthly)";
      }
      return "";
    },
  },
};
</script>
<style>
.flex-btns {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

table.comnTbl th,
table.comnTbl td {
  padding: 8px 3px;
  font-size: 14px;
  text-align: center;
}

table.comnTbl td strong {
  display: block;
  text-align: left;
  margin-left: 5%;
}

@media (max-width: 550px) {

  .report-defined h3,
  .report-action h3 {
    font-size: 18px;
  }

  .quarter-btn .col-md-12 br:nth-child(1) {
    display: none;
  }

  #print-box .title h2 {
    font-size: 24px;
  }
}
</style>